var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: { "label-width": "100px", model: _vm.queryCondition },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "单据编号",
                                      prop: "applyNo",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入单据编号",
                                      },
                                      model: {
                                        value: _vm.queryCondition.applyNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "applyNo",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.applyNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "轮次状态",
                                      prop: "roundStatus",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          placeholder: "轮次状态",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.queryCondition.roundStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "roundStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.roundStatus",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: _vm.$t("common.all"),
                                            value: "",
                                          },
                                        }),
                                        _vm._l(
                                          _vm.roundStatusList,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label:
                                                  _vm._f("inputChoiceI18n")(
                                                    item
                                                  ),
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: { label: "入围供应商" },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.supplierCode,
                                        callback: function ($$v) {
                                          _vm.supplierCode = $$v
                                        },
                                        expression: "supplierCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "主题", prop: "subject" } },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        placeholder: "请输入主题",
                                      },
                                      model: {
                                        value: _vm.queryCondition.subject,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "subject",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.subject",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建人",
                                              prop: "buyerName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入创建人",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.buyerName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "buyerName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.buyerName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建日期(从)",
                                              prop: "createDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.createDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "创建日期(至)",
                                              prop: "createEndDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .createEndDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "createEndDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.createEndDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "8位码",
                                              prop: "eightBitCodesStr",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticClass: "handle-input",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "textarea",
                                                autosize: {
                                                  minRows: 2,
                                                  maxRows: 4,
                                                },
                                                clearable: "",
                                                placeholder: "请输入8位码",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .eightBitCodesStr,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "eightBitCodesStr",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.eightBitCodesStr",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center", align: "middle" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.queryData(1)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.search")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.restQueryFormThis()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                ),
                _c(
                  "span",
                  {
                    staticClass: "arrowDown",
                    on: {
                      click: function ($event) {
                        _vm.isShow = !_vm.isShow
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                    _c("i", {
                      class: _vm.isShow
                        ? "el-icon-arrow-up iconBtn"
                        : "el-icon-arrow-down iconBtn",
                    }),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "quotationDataTable",
            attrs: {
              data: _vm.quotationList,
              border: "",
              "max-height": "470",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "选择", width: "50" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: scope.row.ttQuotationApplyRoundId },
                          nativeOn: {
                            change: function ($event) {
                              return _vm.getSelectRow(scope.row)
                            },
                          },
                          model: {
                            value: _vm.radioVal,
                            callback: function ($$v) {
                              _vm.radioVal = $$v
                            },
                            expression: "radioVal",
                          },
                        },
                        [_vm._v(" ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "date",
                label: "单据编号",
                "min-width": "100px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openQuotationApplyDetail(scope.row)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(scope.row.applyNo) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "subject",
                label: "主题",
                "min-width": "180px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "supplierNames",
                label: "入围供应商",
                "min-width": "140px",
              },
            }),
            _c("el-table-column", {
              attrs: { sortable: "", label: "操作", "min-width": "80px" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      scope.row.roundStatus !== "4"
                        ? _c(
                            "el-link",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.openQuotationDetail(scope.row)
                                },
                              },
                            },
                            [_vm._v("报价 ")]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "roundNumber",
                label: "轮次",
                "min-width": "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.openQuotationHistory(
                                scope.row.ttQuotationApplyId
                              )
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(scope.row.roundNumber) + " ")]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "",
                prop: "roundStatusI18n",
                label: "轮次状态",
                "min-width": "90px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "name",
                label: "创建人",
                "min-width": "120px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                sortable: "",
                prop: "createDate",
                label: "创建日期",
                "min-width": "100px",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              "el-dialog": "",
              title: "创建新轮次",
              "before-close": _vm.handleClose,
              visible: _vm.dialogVisible,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "createNewRoundForm",
                attrs: {
                  model: _vm.createNewRoundForm,
                  "label-width": "120px",
                  inline: "true",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "单据编号:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "主题:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "轮次:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "轮次说明:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "textarea" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { width: "320px" },
                    attrs: {
                      label: "附件:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          action: "https://jsonplaceholder.typicode.com/posts/",
                          "on-change": _vm.handleChange,
                          "file-list": _vm.fileList,
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "mini", type: "primary" } },
                          [_vm._v("点击上传")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: " " } },
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", size: "mini" } },
                      [_vm._v("提交")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-table",
              {
                staticClass: "dialogIntable",
                attrs: {
                  data: _vm.quotationList,
                  border: "",
                  "highlight-current-row": "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "date",
                    label: "供应商编号",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "name",
                    label: "供应商名称",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "show-overflow-tooltip": "",
                    sortable: "",
                    prop: "address",
                    label: "本轮是否发放",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              "el-dialog": "",
              title: "询报价详细",
              "before-close": _vm.handleClose,
              visible: _vm.quotationVisible,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.quotationVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "createNewRoundForm",
                attrs: {
                  model: _vm.createNewRoundForm,
                  "label-width": "120px",
                  inline: "true",
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "单据编号:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "主题:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "创建人:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "创建日期:",
                      prop: "documentNumber",
                      size: "small",
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: { readonly: "" },
                      model: {
                        value: _vm.createNewRoundForm.documentNumber,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.createNewRoundForm,
                            "documentNumber",
                            $$v
                          )
                        },
                        expression: "createNewRoundForm.documentNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: _vm.$t("apply.newRound"),
              visible: _vm.showNewRoundDialog,
              width: "65%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showNewRoundDialog = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "pickupPointForm",
                staticClass: "form_border",
                attrs: {
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "handle-box" },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showSaveNewRoundFlag,
                                expression: "showSaveNewRoundFlag",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: { click: _vm.saveNewRoundFunc },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.submit")))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        ref: "newRoundHeadDataForm",
                        attrs: {
                          model: _vm.newRoundHeadData,
                          "label-position": _vm.labelPosition,
                          "label-width": "140px",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 7 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("apply.no") } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.newRoundHeadData.applyNo,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newRoundHeadData,
                                            "applyNo",
                                            $$v
                                          )
                                        },
                                        expression: "newRoundHeadData.applyNo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 7 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("apply.applyType"),
                                      prop: "applyType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: true },
                                        model: {
                                          value: _vm.newRoundHeadData.applyType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newRoundHeadData,
                                              "applyType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newRoundHeadData.applyType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.applyTypeList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm._f("inputChoiceI18n")(item),
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 7 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("apply.subject") } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.newRoundHeadData.subject,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newRoundHeadData,
                                            "subject",
                                            $$v
                                          )
                                        },
                                        expression: "newRoundHeadData.subject",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 7 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("apply.quotationType"),
                                      prop: "quotationType",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { disabled: true },
                                        model: {
                                          value:
                                            _vm.newRoundHeadData.quotationType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newRoundHeadData,
                                              "quotationType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newRoundHeadData.quotationType",
                                        },
                                      },
                                      _vm._l(
                                        _vm.quotationTypeList,
                                        function (item, index) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label:
                                                _vm._f("inputChoiceI18n")(item),
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 7 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: _vm.$t("apply.round") } },
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: true },
                                      model: {
                                        value: _vm.newRoundNumber,
                                        callback: function ($$v) {
                                          _vm.newRoundNumber = $$v
                                        },
                                        expression: "newRoundNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 18 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("apply.roundRemark"),
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "textarea" },
                                      model: {
                                        value: _vm.roundRemark,
                                        callback: function ($$v) {
                                          _vm.roundRemark = $$v
                                        },
                                        expression: "roundRemark",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 18 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("common.attachment"),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "upload",
                                        staticClass: "upload-demo",
                                        attrs: {
                                          headers: _vm.header,
                                          action: _vm.fileUploadUrl,
                                          "on-success": _vm.uploadSuccess,
                                          "on-remove": _vm.handleRemove,
                                          multiple: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "primary",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("common.selectFile")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 18 } },
                              [
                                _c(
                                  "el-table",
                                  {
                                    ref: "supplierListDataTable",
                                    attrs: {
                                      data: _vm.supplierList,
                                      border: "",
                                      "highlight-current-row": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "supplierCode",
                                        label: _vm.$t("apply.supplierCode"),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "supplierName",
                                        label: _vm.$t("apply.supplierName"),
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        width: "55px",
                                        prop: "tmSupplierId",
                                        selectable: _vm.selectableMethod,
                                        type: "selection",
                                        label: _vm.$t("apply.whetherToIssue"),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }